import { useLocation, useNavigate } from 'react-router'
import { ArrowLeft, CreditCard, Gift, User } from 'lucide-react'
import { cn } from '@/shared/lib/utils'
import { useAuthStore } from '@/shared/stores/auth'
import { CountryFlagButton } from './country-flag-button'

const mainTabRoutes = ['/', '/giftcards', '/orders', '/profile']

const desktopNavItems = [
  { label: 'Gift Cards', path: '/giftcards', icon: Gift },
  { label: 'My Cards', path: '/orders', icon: CreditCard, requiresAuth: true },
  { label: 'Profile', path: '/profile', icon: User },
]

export function Header() {
  const location = useLocation()
  const navigate = useNavigate()
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  const isAuthPage = location.pathname.startsWith('/auth')
  const showBackButton = !isAuthPage && !mainTabRoutes.includes(location.pathname)

  if (isAuthPage) {
    return null
  }

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-[#1d1d24]">
      <div className="relative mx-auto flex max-w-7xl items-center justify-center px-4 py-3 md:justify-between">
        {showBackButton && (
          <button
            onClick={() => navigate(-1)}
            className="absolute left-4 top-1/2 -translate-y-1/2 text-white transition-opacity hover:opacity-80 md:hidden"
            aria-label="Go back"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
        )}

        <div className="flex items-center gap-3">
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault()
              navigate('/')
            }}
            className="flex items-center gap-2 transition-opacity hover:opacity-80"
          >
            <img src="/logo-gradient.svg" alt="" className="h-8 w-auto" />
            <img src="/wordmark.svg" alt="The Bitcoin Company" className="mt-1 h-8 w-auto" />
          </a>
        </div>

        <div className="absolute right-4 flex items-center gap-3 md:hidden">
          {!showBackButton && <CountryFlagButton />}
        </div>

        <nav className="hidden items-center gap-1 md:flex">
          {desktopNavItems
            .filter((item) => !item.requiresAuth || isAuthenticated)
            .map((item) => {
              const isActive =
                location.pathname === item.path || location.pathname.startsWith(item.path + '/')
              const Icon = item.icon
              return (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className={cn(
                    'flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                    isActive ? 'text-primary' : 'text-white/60 hover:text-white'
                  )}
                >
                  <Icon className="h-4 w-4" />
                  {item.label}
                </button>
              )
            })}
          <CountryFlagButton className="ml-2" />
        </nav>
      </div>
    </header>
  )
}
